import AbiERC1155 from '../abis/erc1155.json';
import AbiERC721 from '../abis/erc721.json';

export default class Utils {
    public static validateNumber(value: string): boolean {
        if (!/[0-9]/.test(value)) {
            return false;
        }
        return true;
    }

    public static formatDateString(millSec: string): string {
        return new Date(Number(millSec)).toLocaleString();
    }

    public static wait(milliseconds: number) {
        // eslint-disable-next-line no-promise-executor-return
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }

    public static getHttpProvider(chain: string): string {
        switch (chain) {
            case 'binance':
                return 'https://bsc-dataseed.binance.org/';
            case 'ethereum':
                return 'https://mainnet.infura.io/v3/a3dd44b9e528411a9336df28881619f2';
            default:
                return '';
        }
    }

    public static getContractABI(standard: string) {
        switch (standard.toLowerCase()) {
            case 'erc721':
                return AbiERC721.abi;
            case 'erc1155':
                return AbiERC1155.abi;
            default:
                return AbiERC721.abi;
        }
    }

    static getTimeNow() {
        return Math.floor(Date.now() / 1000);
    }
}
